import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import qs from 'qs';
import React from 'react';
import { connect } from 'react-redux';
import { initialize } from 'redux-form';
import { PERMISSION_ENTITIES, PERMISSIONS } from '../_config/consts';
import { isAreaManagementReadOnlyInMultitenantSharedContext, localizeHelpCenterLink } from '../_config/utils.js';
import AreaTableView from '../components/CapacityManagement/AreaTableView.jsx';
import AreasOperationalSection from '../components/CapacityManagement/AreasOperationalSection.jsx';
import AreasReportView from '../components/CapacityManagement/AreasReportView.jsx';
import AreaIconCustom from '../components/CustomIcons/AreaIconCustom.jsx';
import ChartBoxIconCustom from '../components/CustomIcons/ChartBoxIconCustom.jsx';
import OperationalView from '../components/OperationalView/OperationalView.jsx';
import PresentationalViewHeader from '../components/PresentationalView/PresentationalViewHeader.jsx';
import AbilityProvider from '../permissionsUtils/AbilityProvider.js';
import * as AreaActions from '../redux/actions/area.actions';
import * as FloorPlansActions from '../redux/actions/floorplans.actions.js';
import * as LocksActions from '../redux/actions/lock.actions';
import * as ModalActions from '../redux/actions/modal.actions';
import * as UtilsActions from '../redux/actions/utils.actions';

let filterTimeout;
@connect((state) => ({
  areas: state.areas,
  floorPlans: state.floorPlans,
  routing: state.router,
  viewLoading: state.utils.viewLoading,
  themeName: state.settings.items.theme.data.themeName,
  user: state.user,
  walletSubscriptions: state.cloudCredits?.wallet?.subscriptions?.content,
  areasLocksContent: state.areas?.locks?.content,
}))
class AreasManagement extends React.Component {
  constructor(props) {
    super(props);
    const cachedViewMode = localStorage.getItem('areasViewMode');
    this.state = {
      activeTab: 0,
    };
  }
  async componentWillMount() {
    const { dispatch, routing, areas } = this.props;
    const parsed = qs.parse(routing.location.search, { ignoreQueryPrefix: true });
    dispatch(AreaActions.selectArea({}));
    dispatch(UtilsActions.setSpinnerVisibile(true));
    try {
      dispatch(AreaActions.resetAreasFilters());
      await dispatch(AreaActions.fetchAllLocks());
      await dispatch(AreaActions.fetchAreas());
      await dispatch(FloorPlansActions.fetchFloorPlans());
      dispatch(LocksActions.fetchAllLocksCustomFilters({connectionType:'SMART_CLASSIC_OFFLINE'}));
    } finally {
      dispatch(UtilsActions.setSpinnerVisibile(false));
    }
    const areaId = parsed.areaId;
    const newEntity = parsed.newEntity;
    if (areaId) {
      const newArea = areas.filter(e=>e.id===areaId).length>0?areas.filter(e=>e.id===areaId)[0]:undefined;
      if (newArea) {
        this.selectArea(newArea);
      }
    }
    if (newEntity && !isAreaManagementReadOnlyInMultitenantSharedContext(this.getMultitenantSharedContext())) {
      this.onCreateNewArea();
    }
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(AreaActions.resetAreasFilters());
    dispatch(AreaActions.selectArea({}));
  }

  async fetchAreas(page = 0, append = false) {
    const { dispatch } = this.props;
    try {
      this.setState({ viewLoading: true });
      await dispatch(AreaActions.fetchAreas());
      this.setState({ viewLoading: false });
    } catch (error) {
      this.setState({ viewLoading: false });
    }
  }

  async closeOperationalSection() {
    const { dispatch } = this.props;
    await dispatch(AreaActions.setOperationalMode(false));
    await dispatch(AreaActions.selectArea({}));
  }

  openOperationalSection() {
    const { dispatch } = this.props;
    dispatch(AreaActions.setOperationalMode(true));
  }

  async onSetFilter(field, value, useTimeout) {
    const { dispatch } = this.props;
    if (value && ((_.isArray(value) && !_.isEmpty(value)) || (_.isString(value) && value.length >= 2) || (_.isNumber(value) && value>0))) {
      await dispatch(AreaActions.setFilter(field, value));
      if (useTimeout) {
        if (filterTimeout) clearTimeout(filterTimeout);
        filterTimeout = setTimeout(async () => {
          await this.fetchAreas()
        }, 500);
      }
      else {
        dispatch(UtilsActions.setSpinnerVisibile(true));
        await this.fetchAreas()
        dispatch(UtilsActions.setSpinnerVisibile(false));
      }
    } else {
      if (!useTimeout)
        dispatch(UtilsActions.setSpinnerVisibile(true));
      await dispatch(AreaActions.setFilter(field, undefined));
      await this.fetchAreas()
      if (!useTimeout)
        dispatch(UtilsActions.setSpinnerVisibile(false));
    }
  }

  async onResetFilters() {
    const { dispatch } = this.props;
    await dispatch(AreaActions.resetAreasFilters());
    dispatch(initialize('AreasFilters', {}));
    await dispatch(AreaActions.fetchAreas());
  }

  async selectArea(area) {
    const { dispatch, areas } = this.props;
    const selectedArea = areas.selectedArea
    if (selectedArea && selectedArea.id === area.id)
      return;
    try {
      dispatch(UtilsActions.setSpinnerVisibile(true));
      dispatch(AreaActions.selectArea(area));
      const isWearableAddonActive = dispatch(UtilsActions.isWearablesManagementActive());
      let areaData = area;
      if (isWearableAddonActive) {
        areaData = {
          ...area,
          gateways: _.map(area.gateways, gateway => ({ value: gateway.id, label: gateway.name })),
          gatewayIds: _.map(area.gateways, gateway => gateway.id),
          requiredGatewaysForWearableDetection: parseFloat(area.requiredGatewaysForWearableDetection) != null ? parseFloat(area.requiredGatewaysForWearableDetection) : 1,
          requiredSecondsForWearableInArea: parseFloat(area.requiredSecondsForWearableInArea) != null ? parseFloat(area.requiredSecondsForWearableInArea) : 1,
        };
      }
      dispatch(initialize('AreaDetailsViewForm', areaData));
      dispatch(UtilsActions.setSpinnerVisibile(false));
      this.openOperationalSection()
    } catch (error) {
      dispatch(AreaActions.selectArea({}));
    } finally {
      
    }
  }

  async onAppendAreas(page) {
    const { dispatch } = this.props;
    const append = true;
    try {
      dispatch(UtilsActions.setSpinnerVisibile(true));
      await dispatch(AreaActions.fetchAreas(page, append));
      dispatch(UtilsActions.setSpinnerVisibile(false));
    } catch (error) {
      dispatch(UtilsActions.setSpinnerVisibile(false));
    }
  }

  onFetchAreaOnPage(page) {
    const { dispatch } = this.props;
    dispatch(AreaActions.fetchAreas(page));
  }

  async onAreaEditConfirmed(areaId,areaData) {
    const { dispatch, areas } = this.props;
    const data = areaData;
    dispatch(UtilsActions.setSpinnerVisibile(true));
    try {
      const areaResponse = await dispatch(AreaActions.editArea(areaId,data));
      dispatch(ModalActions.showModal({
        modalType: 'SUCCESS_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="modalMessage" data={{ modal: 'areaPropertiesAssigned' }} /></h6>),
        },
      }));
      this.closeOperationalSection()
    } finally {
      dispatch(UtilsActions.setSpinnerVisibile(false));
    }
  }

  async onAreaCreateConfirmed(areaData) {
    if (isAreaManagementReadOnlyInMultitenantSharedContext(this.getMultitenantSharedContext())) {
      return;
    }
    const { dispatch, areas } = this.props;
    const data = areaData;
    dispatch(UtilsActions.setSpinnerVisibile(true));
    try {
      await dispatch(AreaActions.createArea(data));
      dispatch(ModalActions.showModal({
        modalType: 'SUCCESS_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="modalMessage" data={{ modal: 'areaCreated' }} /></h6>),
        },
      }));
      if (areas.isOperationalMode) {
        this.closeOperationalSection()
      }
    } finally {
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(AreaActions.resetAreasFilters());
      await dispatch(AreaActions.fetchAreas());
    }
  }

  async onDeleteAreaRequest(selectedAreaId) {
    const { dispatch } = this.props;
    const params = {
      modalType: 'CONFIRM_TO_CONTINUE_MODAL',
      modalProps: {
        title: 'confirmBeforeContinue',
        body: <Entity entity="deleteAreaDataMessage" />,
        onConfirmText: <Entity entity="confirm" />,
        onConfirm: () => this.onDeleteAreaConfirm(selectedAreaId),
        onCancelText: <Entity entity="cancel" />,
        onCancel: () => dispatch(ModalActions.hideModal()),
      },
    };
    dispatch(ModalActions.showModal(params));
  }

  async onDeleteAreaConfirm(selectedAreaId) {  
    const { dispatch } = this.props;
    dispatch(UtilsActions.setSpinnerVisibile(true));
    try {
      await dispatch(AreaActions.deleteArea(selectedAreaId));
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(AreaActions.setOperationalMode(false));
      dispatch(AreaActions.selectArea({}));
      dispatch(ModalActions.showModal({
        modalType: 'SUCCESS_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="modalMessage" data={{ modal: 'areaDeleted' }} /></h6>),
        },
      }));
      this.onRefreshAreas()
    } catch (error) {
      let errorMessage = 'areaDeleteError';
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity={errorMessage} /></h6>),
        },
      }));
    }
  }
  
  async onRefreshAreas() {
    const { areas } = this.props;
    const page = areas && areas.data && areas.data.pagination && areas.data.pagination.number;
    this.onFetchAreaOnPage(page);
  }

  onOrderChanged() {
    const { dispatch } = this.props;
    dispatch(AreaActions.fetchAreas())
  }

  async onCreateNewArea() {
    if (isAreaManagementReadOnlyInMultitenantSharedContext(this.getMultitenantSharedContext())) {
      return;
    }
    const { dispatch } = this.props;
    dispatch(AreaActions.selectArea({}));
    const isWearableAddonActive = dispatch(UtilsActions.isWearablesManagementActive());
    let areaData = {};
    if (isWearableAddonActive) {
      areaData = {
        requiredGatewaysForWearableDetection: 1,
        requiredSecondsForWearableInArea: 1,
      };
    }
    dispatch(initialize('AreaDetailsViewForm', areaData));
    this.openOperationalSection()
  }

  onShowInfo() {
    const helpURL = localizeHelpCenterLink('capacity-management-and-areas-configuration');
    window.open(helpURL);
  }

  onSelectTab(key) {
    this.setState({ activeTab: key });
  }

  getMultitenantSharedContext() {
    const { user, walletSubscriptions, areasLocksContent } = this.props;
    return {
      companyConfigurations: user?.companyConfigurations,
      token: user?.token,
      license: user?.license,
      walletSubscriptions,
      areasLocksContent,
    };
  }

  render() {
    const { areas, themeName } = this.props;
    const { activeTab } = this.state;
    const selectedAreaId = areas?.selectedArea?.id
    const selectedAreaName = areas?.selectedArea?.name;
    const multitenantSharedContext = this.getMultitenantSharedContext();
    const isAreaManagementReadOnly = isAreaManagementReadOnlyInMultitenantSharedContext(multitenantSharedContext);
    const canEditCreateAreas = AbilityProvider.getAbilityHelper().hasPermission([PERMISSIONS.ALL], PERMISSION_ENTITIES.AREA)
      && !isAreaManagementReadOnly;
    return (
      <div>
        <div data-layout-chrome="before-filter" style={{ backgroundColor: 'white', marginLeft: 20 }}>
          <Tabs
            value={activeTab}
            indicatorColor="primary"
            textColor="primary"
            onChange={(e, index) => this.onSelectTab(index)}
            TabIndicatorProps={{
              style: { display: 'none' }
            }}
          >
            <Tab icon={<AreaIconCustom style={{ width: 26 }} />} label={<h5 style={{ margin: 0, fontWeight: 'bold' }}><Entity entity="areas" /></h5>} />
            <Tab icon={<ChartBoxIconCustom style={{ width: 26 }} />} label={<h5 style={{ margin: 0, fontWeight: 'bold' }}><Entity entity="report" /></h5>} />
          </Tabs>
        </div>
        {activeTab === 0 ? (
          <>
          <PresentationalViewHeader
            themeName="light-gray"
            onNewEntity={canEditCreateAreas ? () => this.onCreateNewArea() : null}
            newEntityTitle="addArea"
            newEntityIconName="icon-simple-line-icons-user-following"
            onSearchReset={() => this.onResetFilters()}
            onFilterChange={value => this.onSetFilter('search', _.trim(value), true)}
            onSearchSubmit={() => this.fetchAreas()}
            onInfo={() => this.onShowInfo()}
            infoIconStyle={{ color: 'gray' }}
          />
            <AreaTableView
              onSelectArea={area => this.selectArea(area)}
              onFetchAreaOnPage={page => this.onFetchAreaOnPage(page)}
              onRefreshAreas={() => this.onRefreshAreas()}
              onNewArea={canEditCreateAreas ? () => this.onCreateNewArea() : null}
              onDeleteArea={(areaId) => {this.onDeleteAreaRequest(areaId)}}
              onOrderChanged={() => this.onOrderChanged()}
              multitenantSharedContext={multitenantSharedContext}
            />
            <OperationalView
              themeName={themeName}
              isVisible={areas.isOperationalMode}
              onClose={() => this.closeOperationalSection()}
              onDelete={selectedAreaName && canEditCreateAreas ? () => this.onDeleteAreaRequest(selectedAreaId) : null}
              style={{ margin: 0, padding: 0 }}
              title={<Entity entity={selectedAreaName?selectedAreaName:"createArea"} data={{ name: 'areasOperational' }} key={selectedAreaName} />}
            >
              <AreasOperationalSection
                themeName={themeName}
                multitenantSharedContext={multitenantSharedContext}
                onAreaEditConfirmed={(areaId,AreaData)=>this.onAreaEditConfirmed(areaId,AreaData)}
                onAreaCreateConfirmed={(AreaData)=>this.onAreaCreateConfirmed(AreaData)}
                onRefreshAreas={()=>this.onRefreshAreas()}
              />
            </OperationalView>
          </>
        ) : null}
        {activeTab === 1 ? (
          <AreasReportView />
        ) : null}
      </div>
    );
  }
} 

export default AreasManagement;
